import FooterLogo from './FooterLogo';
import { logoColumns } from './footerLogosList';

const ImagesFooter = () => (
  <div className='col-12 d-none d-md-block mb-4'>
    <hr />
    <div className='d-flex justify-content-center'>
      <div style={{ width: '20%' }}>
        {logoColumns[1].map(({ id, url, logoBnW, logoColor, width, height, alt }) => (
          <FooterLogo
            key={id}
            url={url}
            logoBnW={logoBnW}
            logoColor={logoColor}
            alt={alt}
            width={width ?? '170'}
            height={height ?? '70'}
          />
        ))}
      </div>
      <div style={{ width: '20%' }}>
        {logoColumns[2].map(({ id, url, logoBnW, logoColor, width, height, alt }) => (
          <FooterLogo
            key={id}
            url={url}
            logoBnW={logoBnW}
            logoColor={logoColor}
            alt={alt}
            width={width ?? '170'}
            height={height ?? '70'}
          />
        ))}
      </div>
      <div style={{ width: '20%' }}>
        {logoColumns[3].map(({ id, url, logoBnW, logoColor, width, height, alt }) => (
          <FooterLogo
            key={id}
            url={url}
            logoBnW={logoBnW}
            logoColor={logoColor}
            alt={alt}
            width={width ?? '170'}
            height={height ?? '70'}
          />
        ))}
      </div>
      <div style={{ width: '20%' }}>
        {logoColumns[4].map(({ id, url, logoBnW, logoColor, width, height, alt }) => (
          <FooterLogo
            key={id}
            url={url}
            logoBnW={logoBnW}
            logoColor={logoColor}
            alt={alt}
            width={width ?? '170'}
            height={height ?? '70'}
          />
        ))}
      </div>
      <div style={{ width: '20%' }}>
        {logoColumns[5].map(({ id, url, logoBnW, logoColor, width, height, alt }) => (
          <FooterLogo
            key={id}
            url={url}
            logoBnW={logoBnW}
            logoColor={logoColor}
            alt={alt}
            width={width ?? '170'}
            height={height ?? '70'}
          />
        ))}
      </div>
    </div>
  </div>
);

export default ImagesFooter;
